import api from '@/lib/api';

export const mediaApi = {
  getAssets: (params) => api.get('/media/assets', { params }),
  getAsset: (id) => api.get(`/media/assets/${id}`),
  updateAsset: (id, data) => api.patch(`/media/assets/${id}`, data),
  deleteAsset: (id) => api.delete(`/media/assets/${id}`),
  uploadAsset: (formData) => api.post('/media/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  recordUsage: (id, data) => api.post(`/media/assets/${id}/usage`, data),
  getUsage: (id) => api.get(`/media/assets/${id}/usage`),
  assignImage: (params) => api.get('/media/assign', { params }),
};